import { AbsoluteCenter, Box, Button, Heading, Spacer } from "@chakra-ui/react";
import { Helmet } from "react-helmet";

export const NotFoundPage = () => {
  return (
    <AbsoluteCenter>
      <Helmet>
        <title>Not Found - Prompt Studio</title>
      </Helmet>
      <Box>
        <Heading>404 Not Found</Heading>
        <Spacer height="4" />
        <Button
          onClick={() => {
            window.location.href = "/";
          }}
          size="md"
        >
          Take me Home
        </Button>
      </Box>
    </AbsoluteCenter>
  );
};
